import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList, DataDetail } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportAuditRoad.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportAuditRoad.DataList

export const selectReportDetail = (state: RootState): DataDetail =>
  state.adminReportAuditRoad.DataDetail

export const selectFilter = (state: RootState) =>
  state.adminReportAuditRoad.Filter

export const selectInitFilter = (state: RootState) =>
  state.adminReportAuditRoad.ClearFilter

export const selectSorting = (state: RootState) =>
  state.adminReportAuditRoad.sorting
